import React from 'react';
import videoDefaultImg from '@/pages/opinion/assets/imgs/post-default-img.jpg';
import './index.scss';
import { Button, Modal } from 'tea-component';
import {
  getFeedsTitleText,
  getFeedsTopicEle,
  getNewsContentText,
} from '@/pages/opinion/utils/languageValue';
import RenderImg from '@/pages/opinion/components/RenderImg';
import { reviewsFormat } from '@/pages/opinion/utils/value';
import { getLocale, useIntl } from 'umi';
import { transChannel, transRegion } from '@/pages/opinion/utils';
import moment from 'moment';
import { openWindowUrl } from '@/pages/opinion/utils/url';
import SentimentEditBox from '@/pages/opinion/components/SentimentEditBox';
import appfamitsuIcon from '@op/assets/svg/appfamitsu-icon.svg';
import RegionCountryItem from '@/pages/opinion/components/Snippets/RegionCountryItem';
import ChannelLabel from '@op/components/ChannelLabel';
import { dealwithBiLiBiLiImage } from '@op/utils/cdnUrl';

function getUpdateFilter(cvm: any) {
  return {
    unified_id: cvm.unified_id,
    edition_id: cvm.edition_id,
    comment_time: moment(cvm.comment_time).format('YYYY-MM-DD HH:mm:ss'),
    comment_uin: cvm.comment_uin,
    comment_create_time: moment(cvm.create_time).format('YYYY-MM-DD HH:mm:ss'),
  };
}
const NewsModal = ({ visible, close, data, languageType }: any) => {
  const {
    news_language,
    cover,
    engagement,
    visit_number,
    source,
    release_time,
    market,
    sentiment_rating,
  } = data || {};
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const textChannel = transChannel(source);
  const newCover = dealwithBiLiBiLiImage(cover);
  return (
    <Modal
      size={800}
      className="dbo-news-modal"
      visible={visible}
      caption={formatMessage({ id: 'News' })}
      onClose={close}
    >
      <Modal.Body>
        <div className="dbo-news-modal-body">
          <div className="dbo-news-modal-desc">
            <SentimentEditBox
              data={data}
              realValue={sentiment_rating}
              needRequest
              type="news"
            ></SentimentEditBox>
            <span className="dbo-news-modal-line"></span>
            <span className="dbo-news-time">
              {moment(release_time).format('YYYY-MM-DD HH:mm:ss')}
            </span>
            <span className="dbo-news-modal-line"></span>
            <ChannelLabel
              showText={false}
              className="dbo-news-icon"
              channel_name={textChannel}
              defaultImage={appfamitsuIcon}
            ></ChannelLabel>
            <span className="dbo-news-text">{textChannel}</span>

            <span className="dbo-news-modal-line"></span>

            <RegionCountryItem
              showText={false}
              market={market}
            ></RegionCountryItem>
            {news_language && (
              <span className="dbo-news-text">
                {transRegion(news_language, locale === 'en-US' ? 3 : 6)}
              </span>
            )}
          </div>
          <div className="dbo-news-modal-title">
            {getFeedsTitleText(data, languageType)}
          </div>
          <div className="dbo-news-modal-flex">
            <div className="dbo-news-left">
              {getFeedsTopicEle(data, languageType)}
              {/* {news_language && (
                <span className="dbo-news-item">
                  {transRegion(news_language, locale === 'en-US' ? 3 : 6)}
                </span>
              )} */}
            </div>
            <div className="dbo-news-rt">
              {visit_number > 0 && (
                <div className="dbo-news-rt-text">
                  <span className="dbo-news-rt-weight">
                    {reviewsFormat(visit_number)}
                  </span>
                  {formatMessage({ id: 'Reach' })}
                </div>
              )}
              {engagement > 0 && (
                <div className="dbo-news-rt-text">
                  <span className="dbo-news-rt-weight">
                    {reviewsFormat(engagement)}
                  </span>
                  {formatMessage({ id: 'Engagement' })}
                </div>
              )}
            </div>
          </div>
          {cover && (
            <div className="dbo-news-modal-img">
              <RenderImg
                className="dbo-news-item-left"
                coverImage={newCover}
                defaultImage={videoDefaultImg}
                style={{ height: '100%' }}
              ></RenderImg>
            </div>
          )}
          <div className="dbo-news-modal-text">
            {getNewsContentText(data, languageType)}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={!data.news_url}
          type="primary"
          onClick={() => {
            openWindowUrl(data.news_url);
          }}
        >
          {formatMessage({ id: 'Go to' })}
        </Button>
        <Button type="weak" onClick={close}>
          {formatMessage({ id: 'Cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NewsModal;
